<template>
  <div>
    <div class="control push-down">
      <h3 v-html="title" />
      <p v-html="description" />
    </div>
    <div class="control">
      <button
        class="button large"
        data-test-callme-booking-receipt-button
        @click="emitClose"
        v-html="closeButtonLabel"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CallMeBookingReceipt',
  props: {
    title: {
      type: String,
      default() {
        return 'Tak for at bestille et opkald';
      }
    },
    description: {
      type: String,
      default() {
        return '<p>Tak for din opkaldsbestilling. Du hører fra os.</p>';
      }
    },
    closeButtonLabel: {
      type: String,
      default() {
        return 'Luk';
      }
    }
  },
  methods: {
    emitClose(): void {
      this.$emit('booking-close');
    }
  }
});
</script>
